import { BlockMath, InlineMath } from "react-katex";
import FractionInput from "../../../../components/inputs/FractionInput";
import React from "react";

// lokalna funkcja pomocnicza
function getRandomInt(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

// ==== GENERATOR ====

export function generateTask(options = {}) {
  const multiplierSet = [2, 3, 4, 5, 6, 7];
  const requiredMultiple = multiplierSet[getRandomInt(0, multiplierSet.length - 1)];

  let a1, r, k, targetIndex, targetValue;

  do {
    a1 = getRandomInt(1, 10);
    r = getRandomInt(2, 6);
    k = getRandomInt(2, 7);
    const forcedTargetIndex = Number(options.targetIndex);
    const minTargetIndex = Number(options.minTargetIndex) || 4;
    const maxTargetIndex = Number(options.maxTargetIndex) || 5;
    targetIndex = Number.isInteger(forcedTargetIndex)
      ? forcedTargetIndex
      : getRandomInt(minTargetIndex, maxTargetIndex);

    const values = [a1];
    for (let i = 1; i < targetIndex; i++) {
      values.push(k * values[i - 1] + r);
    }

    targetValue = values[values.length - 1];
  } while (targetValue % requiredMultiple !== 0);

  return {
    type: "CompleteRecursiveTask",
    data: {
      a1,
      r,
      k,
      targetIndex,
      targetValue
    }
  };
}


export function generateSimpleTask() {
  const multiplierSet = [2, 3, 4, 5, 6, 7];
  const requiredMultiple = multiplierSet[getRandomInt(0, multiplierSet.length - 1)];

  let a1, r, k, targetValue;

  do {
    a1 = getRandomInt(1, 10);
    r = getRandomInt(2, 6);
    k = getRandomInt(2, 7);
    targetValue = k * a1 + r;
  } while (targetValue % requiredMultiple !== 0);

  return {
    type: "CompleteRecursiveTask",
    data: {
      a1,
      r,
      k,
      targetIndex: 2,
      targetValue
    }
  };
}


// ==== RENDER ====

export function renderTask({ data }) {
  const { a1, r, k, targetIndex } = data;

  return (
    <div className="space-y-2">
      <p>Dany jest ciąg określony rekurencyjnie:</p>
      <BlockMath math={`\\begin{cases}a_1=${a1},\\\\a_{n+1}=${k}a_n+${r} & \\text{dla } n\\ge 1.\\end{cases}`} />
      <p>Oblicz wyraz <InlineMath math={`a_{${targetIndex}}`} /> tego ciągu.</p>
    </div>
  );
}


export function renderInput({ data }, userAnswer, onChange, disabled) {
  const { targetIndex } = data;

  return (
    <FractionInput
      label={`a_{${targetIndex}}`}
      value={userAnswer}
      onChange={onChange}
      disabled={disabled}
    />
  );
}

export function checkAnswer({ data }, userAnswer) {
  const { targetValue, targetIndex } = data;

  if (!userAnswer || typeof userAnswer !== "object") return false;
  const given = userAnswer.parsed;
  if (given === null) return false;

  userAnswer.n = targetIndex;

  return Math.abs(given - targetValue) < 0.01;
}

export function renderAnswer({ data }) {
  const { targetIndex, targetValue } = data;
  return <InlineMath math={`a_{${targetIndex}} = ${targetValue}`} />;
}

export function renderExplanation({ data }) {
  const { a1, r, k, targetIndex, targetValue } = data;

  const steps = [];

  // Krok 1 – wzór
  steps.push(
    <div key="step1">
      <strong>Krok 1:</strong> Zapisujemy wzór rekurencyjny:
      <BlockMath math={`\\begin{cases}a_1=${a1},\\\\a_{n+1}=${k}a_n+${r} & \\text{dla } n\\ge 1.\\end{cases}`} />
    </div>
  );

  // Krok 2+ – obliczenia kolejnych wyrazów
  let current = a1;
  for (let i = 2; i <= targetIndex; i++) {
    const prev = current;
    const next = k * prev + r;

    steps.push(
      <div key={`step${i}`}>
        <p><strong>Krok {i}:</strong> Obliczamy <InlineMath math={`a_{${i}}`} />:</p>
        <BlockMath
          math={`a_{${i}} = ${k} \\cdot a_{${i - 1}} + ${r} = ${k} \\cdot ${prev} + ${r} = ${next}`}
        />
      </div>
    );

    current = next;
  }

  // Odpowiedź końcowa
  steps.push(
    <div key="final">
      <strong>Odpowiedź:</strong>
      <BlockMath math={`a_{${targetIndex}} = ${targetValue}`} />
    </div>
  );

  return <div className="space-y-3" style={{ textAlign: "left" }}>{steps}</div>;
}


export function renderUserAnswer(userAnswer) {
  const n = userAnswer?.n ?? '?';

  if (!userAnswer || typeof userAnswer !== "object" || !userAnswer.raw) {
    return <i>(brak odpowiedzi)</i>;
  }

  return <InlineMath math={`a_{${n}} = ${userAnswer.raw}`} />;
}
